import { http } from '@/api/http'
import { find } from 'lodash'
import ActionCable from 'actioncable'

const channel = 'NotificationChannel',
  subscriptionIdentifier = `{"channel":"${channel}"}`,
  options = { received: received, disconnected: disconnected },
  cable = ActionCable.createConsumer()

let handleIncomingNotification = function(data) {}

function received(data) {
  if (data.text.trim().length === 0) return

  // dataInFormat = { identifier: sender.email,
  //                  name: sender.full_name,
  //                  message: message }
  handleIncomingNotification(data)
}

function disconnected() {
//  Not sure what logic (if any) should be here
}

function subscriptionExists() {
  return find(cable.subscriptions.subscriptions, function(sub) { return sub.identifier === subscriptionIdentifier })
}


const notification = function(handleNotificationFunction) {
  handleIncomingNotification = handleNotificationFunction

  return {
    createSubscription: function() {
      if (subscriptionExists()) return false

      cable.subscriptions.create(channel, options)
    },

    removeSubscription: function() {
      const subscription = subscriptionExists()
      if (subscription) cable.subscriptions.remove(subscription)
    },

    latest: function() {
      if (subscriptionExists()) http.get(`${process.env.VUE_APP_API_URL}notifications/latest`)
    },

    mark_as_old: function(ids) {
      if (subscriptionExists()) http.get(`${process.env.VUE_APP_API_URL}notifications/mark_as_old`, { id: ids })
    },
  }
}

export default notification
